import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as NoteActions from '../_actions/note';
import { Note } from '../_models';

export interface NoteState extends EntityState<Note> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Note> = createEntityAdapter<Note>();

const initialState: NoteState = adapter.getInitialState({
  loading: false,
  error: null,
});

const noteReducer = createReducer(
  initialState,

  on(NoteActions.loadNotes, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(NoteActions.loadNotesSuccess, (state, { notes }) =>
    adapter.setAll(notes, { ...state, loading: false })
  ),

  on(NoteActions.loadNotesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(NoteActions.addNoteSuccess, (state, { note }) => adapter.addOne(note, state)),

  on(NoteActions.updateNoteSuccess, (state, { note }) => adapter.upsertOne(note, state)),

  on(NoteActions.deleteNoteSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    NoteActions.addNoteFailure,
    NoteActions.updateNoteFailure,
    NoteActions.deleteNoteFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: NoteState | undefined, action: Action) {
  return noteReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
